import { Component } from '@poa/core';
import { action, observable, Observer } from '@poa/state';
import React from 'react';
import Navbar from '../components/navbar';
import RouteLoading from '../components/route-loading';
import { GRANTED_HOSTS } from '../store/auth/auth.constants';
import CredModal from '../components/demons-modal/cred-modal';

function zeroPad(num, places) {
  const zero = places - num.toString().length + 1;
  return Array(+(zero > 0 && zero)).join('0') + num;
}

function renderTime(timestamp) {
  if (timestamp) {
    const dd = new Date(timestamp * 1000);
    if (isNaN(dd)) {
      return '-';
    }
    let out;
    out = zeroPad(dd.getDate(), 2) + '.' + zeroPad(dd.getMonth() + 1, 2) + '.' + dd.getFullYear();
    out += ' ' + zeroPad(dd.getHours(), 2) + ':' + zeroPad(dd.getMinutes(), 2);
    return out;
  }
  return '-';
}

function renderTableValue(value) {
  return value || '-';
}

export class ButtonWithLoading extends React.Component {
  state = { isLoading: false };

  onClick = async event => {
    event.preventDefault();
    this.setState({ isLoading: true });

    try {
      await this.props.onClick();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <button type='button' className='filter-columns__save' onClick={this.onClick}>
        {this.state.isLoading ? '........' : this.props.children}
      </button>
    );
  }
}

class DaemonsPage extends React.Component {
  store; // injected by Poa
  actions; // injected by Poa

  refreshDaemonsIntervalRef;

  localState = observable({
    selectedMonth: new Date().getMonth() + 1,
    selectedYear: new Date().getFullYear(),
    isCredModalOpened: false,
    selectedCredId: null
  });

  onCredModalOpen = action(credId => {
    this.localState.selectedCredId = credId;
    this.localState.isCredModalOpened = true;
  });

  onCredModalClose = action(() => {
    this.localState.isCredModalOpened = false;
    this.localState.selectedCredId = null;
  });

  componentDidMount() {
    this.refreshDaemonsIntervalRef = setInterval(this.actions.daemonsActions.fetchDaemons, 3000);
  }

  componentWillUnmount() {
    clearInterval(this.refreshDaemonsIntervalRef);
  }

  render() {

    const body = this.store.daemons.data.map(daemon => {
      return (
        (this.store.auth.currentHost !== 'of') ?
          <tr key={daemon.daemonId} style={{ backgroundColor: daemon.credStatus === 'active' ? 'transperent' : '#f0eded' }}>
            <td style={{ width: '150px', overflowWrap: 'break-word' }}><strong>{renderTableValue(daemon.panel)}</strong>
            </td>
            <td style={{ width: '150px' }}>{renderTableValue(daemon.state)}</td>
            <td style={{
              width: '150px',
              color: (daemon.status === 'logged out') ? 'red' : 'black'
            }}>
              {renderTableValue(daemon.status)}
            </td>
            <td style={{ width: '140px' }}>{renderTime(renderTableValue(daemon.acc_sync))}</td>
            <td style={{ width: '140px' }}>{renderTime(renderTableValue(daemon.stat_sync))}</td>
            <td style={{ width: (this.store.auth.currentHost !== 'of') ? '200px' : '150px' }}>
              {daemon.status === 'logged in' ? (
                <div className='table-actions'>
                  <div>
                    <ButtonWithLoading
                      type='button'
                      onClick={() => this.actions.daemonsActions.syncStats(daemon.daemonId)}
                      className='filter-columns__save'
                    >
                      stats
                    </ButtonWithLoading>
                  </div>
                </div>
              ) : (
                <div className='table-actions'>
                  <div>
                  </div>
                </div>
              )}
            </td>
          </tr>
          : (
            <tr key={daemon.daemonId} style={{ backgroundColor: daemon.credStatus === 'active' ? 'transperent' : '#f0eded' }}>
              <td style={{ width: '100px', overflowWrap: 'break-word' }}><strong>{renderTableValue(daemon.panel)}</strong></td>
              <td style={{ width: '60px' }}>{renderTableValue(daemon.account)}</td>
              <td style={{ width: '60px' }}>{renderTableValue(daemon.state)}</td>
              <td style={{ width: '60px', color: (daemon.status === 'logged out') ? 'red' : 'black' }}>
                {renderTableValue(daemon.status)}
              </td>
              {/* TRACKING and TRIAL Status */}
              <td style={{ width: '60px' }}>{renderTableValue(daemon.trial)}</td>
              <td style={{ width: '60px' }}>{renderTableValue(daemon.tracking)}</td>


              {/* Proxy */}
              <td style={{ width: '60px', color: (daemon.proxy === 'active') ? 'green' : 'red' }}>
                {renderTableValue(daemon.proxy)}
              </td>


              {/* TRACKING and TRIAL Time */}
              <td style={{ width: '80px' }}>{renderTime(renderTableValue(daemon.trial_sync))}</td>
              <td style={{ width: '80px' }}>{renderTime(renderTableValue(daemon.tracking_sync))}</td>
              <td style={{ width: '80px' }}>{renderTime(renderTableValue(daemon.stat_sync))}</td>
              <td style={{ width: '80px' }}>{renderTime(renderTableValue(daemon.acc_sync))}</td>

              <td style={{ width: '200px' }}>
                <div className='table-actions'>
                  <div>
                    <ButtonWithLoading
                      type='button'
                      onClick={() => this.actions.daemonsActions.syncStats(daemon.daemonId)}
                      className='filter-columns__save'
                    >
                      stats
                    </ButtonWithLoading>
                  </div>
                  <div>
                    <button
                      type='button'
                      onClick={() => this.onCredModalOpen(daemon.daemonId)}
                      className='filter-columns__save'
                    >
                      update cred
                    </button>
                  </div>
                </div>
              </td>
            </tr>
          )
      );
    });

    return (
      <RouteLoading meta={this.store.daemons.meta} >
        <div className='content'>
          <Navbar />

          <div className='under-navbar-content'>
            <div className='filters'>
              <div className='filters__inner inner' style={{ marginRight: '8px' }}>
                <div className='filters__left daemons-filters-left'>
                  <div className='filter'>
                    {this.store.auth.currentHost === GRANTED_HOSTS.of ?
                      <button
                        onClick={() => this.localState.isCredModalOpened = true}
                        className='filter-columns__save'
                      >
                        Create Cred
                      </button> : null}
                  </div>
                </div>
                <div className='filters__right'>
                  <div className='filter'>
                    <span className='filter__label' style={{ paddingTop: 0 }}>
                      current {renderTime(this.store.daemons.meta.syncStatus.current) || ' - '}
                    </span>
                  </div>
                  <div className='filter'>
                    <span className='filter__label' style={{ paddingTop: 0 }}>
                      next {renderTime(this.store.daemons.meta.syncStatus.next) || ' - '}
                    </span>
                  </div>

                  <div className='filter' style={{ marginRight: '5px' }}>
                    <button
                      onClick={this.actions.daemonsActions.syncAccountsAll}
                      className='filter-columns__save'
                    >
                      accounts
                    </button>
                  </div>
                  <div className='filter' style={{ marginRight: '5px' }}>
                    <button
                      onClick={this.actions.daemonsActions.syncStatsAll}
                      className='filter-columns__save'
                    >
                      stats
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className='content reports-page'>
                <div className='container'>
                  <div className='inner'>
                    <div className='inner-scroll'>
                      <div className='table-container'>
                        <div className='table-container__body'>
                          <table className='table' style={{ tableLayout: 'fixed' }}>
                            <thead>
                              {
                                (this.store.auth.currentHost === 'of') ? (
                                  <tr>
                                    <th style={{ width: '100px' }}>ID</th>
                                    <th style={{ width: '60px' }}>Acc.</th>
                                    <th style={{ width: '60px' }}>Стат</th>
                                    <th style={{ width: '60px' }}>Статус</th>
                                    <th style={{ width: '60px' }}>Trial С</th>
                                    <th style={{ width: '60px' }}>Tracking С</th>
                                    <th style={{ width: '60px' }}>Proxy</th>
                                    <th style={{ width: '80px' }}>Trial</th>
                                    <th style={{ width: '80px' }}>Tracking</th>
                                    <th style={{ width: '80px' }}>Статистика</th>
                                    <th style={{ width: '80px' }}>Анкеты</th>
                                    <th style={{ width: '200px', textAlign: 'right' }}>
                                      Управление
                                    </th>
                                  </tr>
                                ) : (
                                  <tr>
                                    <th style={{ width: '150px' }}>ID</th>
                                    <th style={{ width: '150px' }}>Состояние</th>
                                    <th style={{ width: '150px' }}>Статус</th>
                                    <th style={{ width: '140px' }}>Аккаунты</th>
                                    <th style={{ width: '140px' }}>Статистика</th>
                                    <th style={{ width: '150px', textAlign: 'right' }}>
                                      Управление
                                    </th>
                                  </tr>
                                )
                              }
                            </thead>
                            <tbody>{body}</tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Observer>
              {() => (
                <CredModal
                  isOpen={this.localState.isCredModalOpened}
                  onRequestClose={this.onCredModalClose}
                  selectedCredId={this.localState.selectedCredId}
                />
              )}
            </Observer>
          </div>
        </div>
      </RouteLoading>
    );
  }
}

export default Component()(DaemonsPage);
